import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
      <h1 className="text-3xl font-bold mb-2">Terms and Conditions</h1>
      <p className="text-sm text-gray-500 mb-6">Last updated: May 20, 2025</p>
      <p className="mb-6">
        Please read these Terms and Conditions carefully before using our
        services or subscribing to our SMS notifications.
      </p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Messaging Frequency</h2>
        <p>
          You may receive up to 5 messages per week from Winik Properties LLC.
          Message frequency may vary based on your relationship with us — such
          as rental reminders, property updates, or maintenance scheduling — but
          we will never exceed the stated weekly limit without your additional
          consent.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Opt-in Process</h2>
        <p>
          To subscribe to SMS alerts from Winik Properties LLC, text{" "}
          <strong>“JOIN”</strong> to <strong>(727) 405 1863</strong>. By doing
          so, you provide explicit consent to receive SMS communications from us
          regarding property management services, rental updates, and other
          relevant notices.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Confirmation Message</h2>
        <p>Once you opt in, you will receive a confirmation message:</p>
        <blockquote className="border-l-4 border-gray-300 pl-4 italic mt-2">
          “You’ve successfully subscribed to Winik Properties LLC SMS alerts.
          Message and data rates may apply. Reply HELP for help, STOP to
          cancel.”
        </blockquote>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Simple Opt-out Method</h2>
        <p>
          You may opt out of receiving SMS messages at any time by replying with
          the word <strong>“STOP”</strong> to <strong>(727) 405 1863</strong>.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Automatic Unsubscription</h2>
        <p>When you send “STOP,” you will receive a confirmation message:</p>
        <blockquote className="border-l-4 border-gray-300 pl-4 italic mt-2">
          “You have unsubscribed and will no longer receive messages from Winik
          Properties LLC.”
        </blockquote>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Alternative Opt-out Method
        </h2>
        <p>
          In addition to SMS opt-out, you can unsubscribe by contacting us via
          email at
          <a
            href="mailto:contact.winikproperties@gmail.com"
            className="text-blue-600 underline"
          >
            {" "}
            contact.winikproperties@gmail.com
          </a>
          or by visiting our contact page at
          <a
            href="https://www.winikproperties.com"
            className="text-blue-600 underline"
          >
            {" "}
            www.winikproperties.com
          </a>
          .
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Online Privacy Policy</h2>
        <p>
          For full details about how we collect, use, and safeguard your
          personal information, please review our{" "}
          <a href="/privacy-policy" className="text-blue-600 underline">
            Privacy Policy
          </a>
          .
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          Compliance with Data Protection Laws
        </h2>
        <p>
          We comply with applicable data protection and privacy laws. Your
          personal information will never be sold or shared with third parties
          for marketing purposes. Data is used only for legitimate business
          purposes related to our property management services.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Disclaimer and Liability</h2>
        <p>
          Message delivery depends on your mobile carrier’s availability. Winik
          Properties LLC is not responsible for delayed or undelivered messages
          due to network issues, technical errors, or service interruptions.
          Standard message and data rates may apply based on your mobile plan.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Changes to Terms</h2>
        <p>
          We may update these Terms and Conditions at any time. Significant
          changes will be communicated through SMS or posted on our website.
          Continued use of our SMS services after updates indicates your
          acceptance of the revised terms.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
